import { useRouteError, isRouteErrorResponse } from "react-router";

export default function Error() {
	const error = useRouteError();
	console.error(error);

	if (isRouteErrorResponse(error)) {
		// Handle specific status codes like 404 or 500
		return (
			<div>
				<h1>{error.status} {error.statusText}</h1>
				<p>{error.data}</p>
			</div>
		);
	}

	return <div>Something went wrong: {error.message}</div>;
}